import React from "react";
import {MallDispatchContext} from '../providers';

function useDispatchMall() {
    return React.useContext(MallDispatchContext);
}

export {useDispatchMall}
